import React from 'react';
import { POSITIONS, VS_POSITIONS } from '../api/rangesApi';
import '../styles/RangeForm.css';

const RangeForm = ({ 
  name, 
  position,
  vsPositions = [],  // Массив выбранных позиций противника
  comment, 
  stackFrom,
  stackTo,
  onNameChange, 
  onPositionChange,
  onVsPositionsChange,  // Обработчик для массива
  onCommentChange,
  onStackFromChange,
  onStackToChange,
  readOnly
}) => {
  // Переключение позиции противника (множественный выбор)
  const toggleVsPosition = (pos) => {
    if (readOnly) return;
    
    if (vsPositions.includes(pos)) {
      // Убираем позицию
      onVsPositionsChange(vsPositions.filter(p => p !== pos));
    } else {
      // Добавляем позицию
      onVsPositionsChange([...vsPositions, pos]);
    }
  };

  // Выбрать все / Снять все
  const selectAllVsPositions = () => {
    if (readOnly) return;
    if (vsPositions.length === VS_POSITIONS.length) {
      onVsPositionsChange([]);
    } else {
      onVsPositionsChange([...VS_POSITIONS]);
    }
  };

  return (
    <div className="range-form">
      <div className="form-row">
        <div className="form-group flex-2">
          <label htmlFor="range-name">Название диапазона</label>
          <input
            id="range-name"
            type="text"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="Например: UTG Open Range"
            className="form-input"
            disabled={readOnly}
          />
        </div>
        
        <div className="form-group stack-group">
          <label>Эффективный стек (BB)</label>
          <div className="stack-inputs">
            <input
              type="number"
              value={stackFrom}
              onChange={(e) => onStackFromChange(parseInt(e.target.value) || 0)}
              placeholder="От"
              className="form-input stack-input"
              min="0"
              max="500"
              disabled={readOnly}
            />
            <span className="stack-separator">—</span>
            <input
              type="number"
              value={stackTo}
              onChange={(e) => onStackToChange(parseInt(e.target.value) || 100)}
              placeholder="До"
              className="form-input stack-input"
              min="0"
              max="500"
              disabled={readOnly}
            />
            <span className="stack-unit">BB</span>
          </div>
        </div>
      </div>
      
      <div className="form-row positions-row">
        <div className="form-group">
          <label>Моя позиция</label>
          <div className="position-selector">
            {POSITIONS.map((pos) => (
              <button
                key={pos}
                className={`position-btn ${position === pos ? 'active' : ''}`}
                onClick={() => !readOnly && onPositionChange(pos)}
                disabled={readOnly}
              >
                {pos}
              </button>
            ))}
          </div>
        </div>
        
        <div className="form-group">
          <label>
            Против позиций
            <span className="vs-count">
              {vsPositions.length > 0 ? ` (${vsPositions.length})` : ' (все)'}
            </span>
            {!readOnly && (
              <button 
                className="select-all-btn"
                onClick={selectAllVsPositions}
                type="button"
              >
                {vsPositions.length === VS_POSITIONS.length ? 'Снять все' : 'Выбрать все'}
              </button>
            )}
          </label>
          <div className="position-selector vs-selector multi">
            {VS_POSITIONS.map((pos) => (
              <button
                key={pos}
                className={`position-btn vs-btn ${vsPositions.includes(pos) ? 'active' : ''} ${pos === 'RFI' || pos === 'MUX' ? 'special' : ''}`}
                onClick={() => toggleVsPosition(pos)}
                disabled={readOnly}
              >
                {pos}
              </button>
            ))}
          </div>
          {vsPositions.length === 0 && (
            <div className="vs-hint">Пусто = применяется ко всем позициям</div>
          )}
        </div>
      </div>
      
      <div className="form-group">
        <label htmlFor="range-comment">Комментарий</label>
        <textarea
          id="range-comment"
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder="Заметки к диапазону..."
          className="form-textarea"
          rows={3}
          disabled={readOnly}
        />
      </div>
    </div>
  );
};

export default RangeForm;
